import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding: ', 'px 0 ', 'px 0;\n'], ['\n  box-sizing: border-box;\n  padding: ', 'px 0 ', 'px 0;\n']);

import styled from 'styled-components';
import { globalPrimaryActions, gridSize } from '../../shared-variables';

var GlobalPrimaryActionsInner = styled.div(_templateObject, gridSize, globalPrimaryActions.margin.bottom);

GlobalPrimaryActionsInner.displayName = 'GlobalPrimaryActionsInner';

export default GlobalPrimaryActionsInner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/GlobalPrimaryActionsInner.js
// module id = 600
// module chunks = 0